/**
 * GlobalComposerHost — mounted once at the root. Reads the `composer` redux
 * slice and renders the ComposerSheet. Any screen can `dispatch(openComposer(
 * { projectId, inboxEmail, initial }))` to open the composer without owning
 * the sheet UI itself.
 *
 * Half of the "inbox useless, compose prominent" delivery: the compose
 * surface is no longer trapped inside InboxScreen.
 */

import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../store';
import { useTheme } from '../hooks/useTheme';
import ComposerSheet from './ComposerSheet';
import { closeComposer, markComposerSent, type ComposerState } from '../store/reducers/composer';

export default function GlobalComposerHost() {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const composer = useSelector((s: any) => s?.composer as ComposerState | undefined);

  const handleClose = useCallback(() => {
    dispatch(closeComposer());
  }, [dispatch]);

  const handleSent = useCallback(() => {
    dispatch(markComposerSent());
  }, [dispatch]);

  if (!composer?.open || composer.projectId == null) return null;

  return (
    <ComposerSheet
      visible={composer.open}
      initial={composer.initial}
      inboxEmail={composer.inboxEmail}
      projectId={composer.projectId}
      onClose={handleClose}
      onSent={handleSent}
      theme={theme}
    />
  );
}
